import { Component, OnInit } from '@angular/core';
import {FieldConfig} from '../field.interface';
import {FormGroup} from '@angular/forms';
import {AppService} from '../../../app.service';


@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.css']
})
export class SlideToggleComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;

    /**
     * Установка надписи
     */
    setOptions(options) {
        this.field.label = options;
    }

    /**
     * Конструктор
     */
    constructor(public appService: AppService) {
    }

    /**
     * После инициализации компонента
     */
    ngOnInit() {}
}
